import { CircleLoader, ColorWay, Div, H4, P } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import React from 'react'

import { userHasAnyPlaybookAccess } from 'utils/access'

import './style.css'

export default function Fallback({
  isEmpty = false,
  isLoading = false,
  isPriority = false,
  hasNameKeyword = false,
}) {
  if (!isEmpty && !isLoading) {
    return null
  }

  const hasAnyPlaybookAccess = userHasAnyPlaybookAccess()

  return (
    <Div className="playbooks-table--fallback">
      {isLoading && (
        <Div className="loading">
          <CircleLoader size="large" />
        </Div>
      )}
      {isEmpty && !isLoading && (
        <>
          <ColorWay type="3">
            <Icon name="cw-empty-search" />
          </ColorWay>
          {isPriority ? (
            <H4>Looks like you don’t have any playbooks yet!</H4>
          ) : (
            <>
              <H4>
                {!hasNameKeyword
                  ? `Looks like you don’t have any ${
                      hasAnyPlaybookAccess ? 'playbooks' : 'sequences'
                    }
              created yet.`
                  : `There are no playbooks that match this search`}
              </H4>
              {!hasNameKeyword && (
                <P>
                  Click on{' '}
                  <em>
                    {hasAnyPlaybookAccess
                      ? 'Create playbook'
                      : 'Create sequence'}
                  </em>{' '}
                  to get started!
                </P>
              )}
            </>
          )}
        </>
      )}
    </Div>
  )
}
